import { inject } from '@angular/core';
import { MessageErrorResolver } from "../../utilities/message-error-resolver"
import { LoadingService } from "./loading.service"
import { HttpClient } from '@angular/common/http';
import { SnackbarService } from './snackbar.service';
import { environment } from '@env/environment';

export class BaseService {
  protected readonly envUrl = environment.apiUrl
  protected readonly messageErrorResolver = inject(MessageErrorResolver);
  protected readonly loadingService = inject(LoadingService);
  protected readonly snackbarService = inject(SnackbarService);
  protected readonly http = inject(HttpClient);
}
